module.exports = window.customFieldsId



// WEBPACK FOOTER //
// ./app/scripts/data/custom-fields-id.coffee